import React, { useEffect, useState } from 'react';
import { apiGet } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Activity, RefreshCw } from 'lucide-react';

export default function AdminAudit() {
  const [activity, setActivity] = useState([]);
  const [action, setAction] = useState('');
  const [actor, setActor] = useState('');
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    const qs = new URLSearchParams();
    if (action) qs.set('action', action);
    if (actor) qs.set('actor', actor);
    apiGet(`/api/audit-log?${qs.toString()}`)
      .then(r => setActivity(r.data.activity || []))
      .catch(() => setActivity([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="animate-fade-in" data-testid="admin-audit-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-slate-50" style={{ fontFamily: "'Outfit', sans-serif" }}>Audit Log</h1>
          <p className="text-sm text-slate-400 mt-1">{activity.length} activity entries</p>
        </div>
        <Button variant="outline" onClick={load} className="bg-slate-800 border-slate-700 text-slate-300 hover:bg-slate-700">
          <RefreshCw className="w-4 h-4" />
        </Button>
      </div>

      <div className="flex flex-wrap gap-3 mb-4">
        <input value={action} onChange={e => setAction(e.target.value)} placeholder="Filter action..." className="bg-slate-900/50 border border-slate-700 rounded-md px-3 py-2 text-sm text-slate-100" />
        <input value={actor} onChange={e => setActor(e.target.value)} placeholder="Filter actor..." className="bg-slate-900/50 border border-slate-700 rounded-md px-3 py-2 text-sm text-slate-100" />
        <Button onClick={load} className="bg-blue-600 hover:bg-blue-500 text-white">Apply</Button>
      </div>

      {loading ? <p className="text-slate-400">Indlæser...</p> : (
        <div className="bg-slate-800/40 border border-slate-700/50 rounded-xl overflow-hidden">
          {activity.length === 0 ? (
            <p className="text-center py-8 text-slate-500 text-sm">Ingen aktivitet fundet.</p>
          ) : activity.map(item => (
            <div key={item.id} className="flex items-start gap-3 p-4 border-b border-slate-700/20 last:border-0">
              <Activity className="w-4 h-4 text-blue-400 mt-0.5" />
              <div className="min-w-0 flex-1">
                <p className="text-sm text-slate-200">{item.action?.replace(/_/g, ' ')}</p>
                <p className="text-xs text-slate-500 truncate">{item.actor || 'system'} {item.details ? `- ${item.details}` : ''}</p>
              </div>
              <span className="text-xs text-slate-600">{item.timestamp ? new Date(item.timestamp).toLocaleString() : ''}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
